import { Timestamp } from "firebase/firestore";
import {Business, LocationOffer, UserCard} from "../types/Types";

export const getActiveOffers = (pointsCard: UserCard | undefined, offers: Array<LocationOffer>) => {
  if(!pointsCard) {
    return offers.filter((offer) => offer.expiresAt == undefined || offer.expiresAt > Timestamp.fromDate(new Date()));
  }
  return offers.filter((offer) => {
    return (offer.expiresAt == undefined
        || offer.expiresAt > Timestamp.fromDate(new Date())) && !usageLimitBreached(pointsCard, offer)
  })
};

export const usageLimitBreached = (offerCard: UserCard, offer: LocationOffer) => {
  return getUsages(offerCard, offer) >= offer.limitPerCard && offer.limitPerCard > 0;
};

export const getUsages = (pointsCard: UserCard | undefined, offer: LocationOffer) => {
  if(pointsCard && offer.cardClaimCounts) {
    // @ts-ignore
    return offer.cardClaimCounts[pointsCard.id];
  }
  return 0;
};

export const getLocation = (businessId: string | undefined, businessMap: Map<string, Business>) => {
  if(!businessId) {
    return
  }
  const business = businessMap.get(businessId);
  if(!business) {
    return
  }
  return business.locations[0];
};

export const convertTimestamp = (timestamp: any): string => {
  const date = new Date(timestamp.seconds * 1000 + timestamp.nanoseconds / 1000000);
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear().toString();
  return `${month}/${year}`;
};

export const convertTimestampToDate = (timestamp: any): string => {
  const date = new Date(timestamp.seconds * 1000 + timestamp.nanoseconds / 1000000);
  const day = date.getDate();
  const daySuffix = (day % 10 === 1 && day !== 11) ? "st" :
      (day % 10 === 2 && day !== 12) ? "nd" :
          (day % 10 === 3 && day !== 13) ? "rd" : "th";
  const monthNames = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
  ];
  const monthName = monthNames[date.getMonth()];
  const year = date.getFullYear();
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');
  return `${day}${daySuffix} ${monthName} ${year}`;
};

export const convertTimestampToDateAndTime = (timestamp: any): string => {
  const date = new Date(timestamp.seconds * 1000 + timestamp.nanoseconds / 1000000);
  const day = date.getDate();
  const daySuffix = (day % 10 === 1 && day !== 11) ? "st" :
      (day % 10 === 2 && day !== 12) ? "nd" :
          (day % 10 === 3 && day !== 13) ? "rd" : "th";
  const monthNames = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
  ];
  const monthName = monthNames[date.getMonth()];
  const year = date.getFullYear();
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');
  const formattedTime = `${hours}.${minutes}`;
  return `${day}${daySuffix} ${monthName} ${year} - ${formattedTime}`;
};

export const convertToFirestoreTimestamp = (dateStr: string): Timestamp => {
  const date = new Date(dateStr);
  return Timestamp.fromDate(date);
};

export const getDistanceFromLatLonInKm = (
    lat1: number,
    lon1: number,
    lat2: number,
    lon2: number
) => {
  const R = 6371; // Radius of the earth in km
  const dLat = deg2rad(lat2 - lat1);
  const dLon = deg2rad(lon2 - lon1);
  const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(deg2rad(lat1)) *
      Math.cos(deg2rad(lat2)) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const d = R * c; // Distance in km
  return d;
};

function deg2rad(deg: number) {
  return deg * (Math.PI / 180);
}

export const cityColour = (cityName: string) => {
  if(cityName == "Madrid") {
    return "red"
  } else if(cityName == "Cardiff") {
    return "darkblue"
  } else {
    return "black"
  }
};